<template>
    <RadioGroup v-model="bindValue" @on-change="handleChange" v-if="isDisplay">
        <Radio 
            v-for="(item, i) in itemList"  
            :key="i"
            :label="item[attrs.valueField] + ''">
            <span> {{ item[attrs.labelField] }}</span>
        </Radio>
    </RadioGroup>
</template>
<script>
/**
 * modify
 * 增加条件判断显示 display
 * wxf
 * 2020-09-18
 */
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    import {mapGetters} from 'Vuex'
    export default {
        name: 'LyRadio',
        mixins: [CompDisplayMixin],
        props: {
            page: {
                type: Object,
                default: _ => {}
            },
            value: {
                type: [String, Number, Boolean],
                default: ''
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        computed: {
            ...mapGetters(['userInfo'])
        },
        watch: {
            value:{
                handler (v) {
                    this.initBindValue()
                },
                immediate: true
            }
        },
        data () {
            return {
                bindValue: '',
                isInitBind: false, // 标识是否初始化绑定过了
                itemList: [],
                timer: null
            }
        },
        created () {
            if ((!this.attrs.api || this.attrs.api.length < 1) && this.attrs.items.length > 0) {
                this.itemList = this.attrs.items
            } else { // 有API的情况
                this.queryItems()
            }
            // 2019-01-19添加，监听page中的属性，然后再根据这个属性进行搜索
            if (this.attrs.watchField && this.attrs.watchField.length > 0) {
                this.$watch('page.' + this.attrs.watchField, function (val) {
                    this.timer && clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        let obj = {}
                        obj[this.attrs.watchField] = val
                        this.queryItems(obj)
                    }, 500)
                }, {
                    deep:true
                })
            }    
        },
        methods: {
            initBindValue () {
                // if ((!this.value && this.value != 0) || this.isInitBind) return
                if (this.value || this.value === 0) {
                    let val = String(this.value)
                    if (val != this.bindValue) {
                        this.bindValue = val 
                    }
                    // this.isInitBind = true
                }
                this.$emit('input', this.bindValue) // 解决默认填充时上传没有值 2019-12-27 wxf
                // this.$eventHub.$emit(this.attrs.field + "Event", this.value)// 全局监听 modify by wxf 2018-11-13
            },
            /**
             * 单选项列表的获取
             */
            queryItems (params) {
                params = params || {}
                this.$api.query(this.attrs.api, params).then((rs) => {
                    this.itemList = rs
                    // 如果列表为空，向上级返回一个时间
                    if (rs.length < 1) {
                        this.$emit('empty')
                    }
                }).catch((err) => {
                    console.log('err:%O', err)
                })
            },
            handleChange (val) {                
                this.$emit('input', val)
                this.$set(this.page, this.attrs.field, val)
                // this.$eventHub.$emit(this.attrs.field, val)// 全局监听 modify by wxf 2018-11-13
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ../projectCore/src/components/radio/src/index.vue